// Mock data for Jaswanth Vasudeva's portfolio - ADMIN EDITABLE
// This file contains all the content that can be managed through the admin panel

export const profileData = {
  name: "Jaswanth Vasudeva",
  fullName: "Vedantam GV V Jaswanth", // Legal name for formal documents
  title: "VC/PE Fellow & Strategic Leader",
  tagline: "Building the future of venture capital and strategic growth initiatives",
  bio: "Strategic and entrepreneurial generalist with engineering foundation from NIT Calicut. Proven experience driving 0-to-1 initiatives across commercial and social sectors. Currently focused on venture capital, strategic partnerships, and building scalable business solutions.",
  location: "Bengaluru, India",
  email: "jaswanthvedantam@gmail.com",
  phone: "+91 94903 96070",
  
  // Profile Images - ADMIN EDITABLE with specified dimensions
  avatarUrl: null, // 400x400px recommended (1:1 ratio), displays 80px-200px depending on screen
  bannerUrl: null, // 1200x400px recommended (3:1 ratio), optional hero background
  
  social: {
    twitter: "", // Admin can add Twitter profile
    linkedin: "https://linkedin.com/in/jaswanthvedantam", // Professional networking
    github: "", // Technical projects showcase
    medium: "", // Writing platform
    substack: "" // Newsletter/blog platform
  },
  
  // SEO and Meta Information - ADMIN EDITABLE
  metaDescription: "Jaswanth Vasudeva - VC/PE Fellow, Strategic Leader, and Engineering Graduate building the future of venture capital",
  keywords: ["venture capital", "strategy", "engineering", "startup", "investment", "business development"]
};

// Writing Portfolio - ADMIN FULLY MANAGEABLE
export const writingPortfolio = {
  summary: "Award-winning writer with National Best Writer Award recognition. Focused on venture capital insights, startup ecosystem analysis, and strategic business commentary.",
  totalViews: "50K+", // Admin can update
  followers: "2K+", // Admin can update
  featured: true,
  
  platforms: [
    {
      id: 1,
      name: "Medium",
      url: "",
      description: "Long-form articles on VC trends and startup insights",
      followers: 500
    },
    {
      id: 2,
      name: "LinkedIn Articles",
      url: "",
      description: "Professional insights and industry analysis",
      followers: 1200
    }
  ]
};

// Career Experience - ADMIN FULLY MANAGEABLE
export const careerExperience = [
  {
    id: 1,
    company: "Lead by Bower",
    role: "VC/PE Fellow",
    period: "Sep 2025 - Present",
    location: "Hyderabad, India",
    description: "Developed and pressure-tested investment theses across high-growth sectors. Conducted deep-dive due diligence on simulated deals, building comprehensive financial models.",
    achievements: [
      "Led simulated term sheet negotiations and modeled complex cap table scenarios",
      "Built extensive network within Hyderabad venture ecosystem",
      "Analyzed 50+ startup pitches across various sectors"
    ],
    logo: null, // Admin can upload company logos - 200x200px recommended
    featured: true
  },
  {
    id: 2,
    company: "Godaari Cacao",
    role: "Head of Strategy & Sales",
    period: "Mar 2025 - Present",
    location: "India",
    description: "Led go-to-market execution and built sales function from ground up, delivering over INR 1 Million in Net profit in 6 months.",
    achievements: [
      "Devised data-driven market research and trend forecasting strategy",
      "Architected 3-year growth strategy with complete business plan",
      "Built sales function generating INR 1M+ net profit in 6 months"
    ],
    logo: null,
    featured: true
  },
  {
    id: 3,
    company: "Carl Zeiss India",
    role: "Software Engineer",
    period: "Jul 2024 - Present",
    location: "Bengaluru, India",
    description: "Spearheaded cost-optimization initiatives and enhanced system reliability through backend development.",
    achievements: [
      "Drove 41% reduction in cloud infrastructure costs",
      "Improved data preparation efficiency by 30%",
      "Resolved critical production bugs enhancing customer experience"
    ],
    logo: null,
    featured: false
  }
];

// Education Background - ADMIN FULLY MANAGEABLE
export const education = [
  {
    id: 1,
    institution: "National Institute of Technology, Calicut",
    degree: "B.Tech in Electrical and Electronics Engineering",
    period: "Dec 2020 - May 2024",
    grade: "GPA: 8.36",
    location: "Calicut, India",
    description: "Top-tier engineering education with focus on electrical systems, electronics, and emerging technologies.",
    achievements: [
      "Maintained high academic performance with 8.36 GPA",
      "Active participation in technical festivals and competitions",
      "Leadership roles in student organizations"
    ],
    logo: null, // Admin can add institution logos
    featured: true
  }
];

// Projects Portfolio - ADMIN FULLY MANAGEABLE
export const projects = [
  {
    id: 1,
    title: "The Fundamental Project",
    description: "Designed and implemented a comprehensive public health initiative addressing critical community needs.",
    category: "Social Impact",
    tags: ["public-health", "social-impact", "leadership"],
    period: "2023",
    status: "completed",
    featured: true,
    technologies: [],
    links: {
      demo: "",
      github: "",
      article: ""
    },
    image: null // 800x400px recommended for project showcase
  }
];

// Skills & Expertise - ADMIN FULLY MANAGEABLE
export const skills = {
  strategic: [
    "Financial Modeling",
    "Market Research & Analysis", 
    "Business Plan Development",
    "Competitive Benchmarking",
    "Go-to-Market Strategy"
  ],
  leadership: [
    "Due Diligence",
    "Deal Sourcing",
    "Stakeholder Engagement",
    "Partnership Development",
    "Cross-Functional Coordination",
    "Public Speaking & Pitching"
  ],
  technical: [
    "SQL",
    "Python", 
    "Azure",
    "PostgreSQL",
    "Power BI",
    "Excel",
    "C#",
    ".NET"
  ]
};

// Awards & Recognition - ADMIN FULLY MANAGEABLE
export const awards = [
  {
    id: 1,
    title: "National Best Writer Award",
    organization: "Indian Film House",
    year: "2024",
    description: "Recognized for exceptional writing talent and contribution to literary arts.",
    category: "Writing",
    featured: true
  },
  {
    id: 2,
    title: "Medhaavi Engineering Scholarship",
    organization: "Bharat Petroleum Corporation Limited (BPCL)",
    year: "2021-2024",
    description: "Merit-based scholarship for outstanding academic performance in engineering.",
    category: "Academic",
    featured: true
  }
];

// Blog Categories - ADMIN FULLY MANAGEABLE (Can add/edit/delete)
export const categories = [
  { id: 1, name: "Venture Capital", slug: "venture-capital", count: 8, description: "Insights into VC trends, investment strategies, and startup ecosystem analysis" },
  { id: 2, name: "Strategic Analysis", slug: "strategic-analysis", count: 12, description: "Deep-dive strategic analysis of business models and market opportunities" },
  { id: 3, name: "Startup Insights", slug: "startup-insights", count: 6, description: "Observations and learnings from the startup ecosystem" },
  { id: 4, name: "Technology", slug: "technology", count: 10, description: "Technical insights, software engineering, and emerging technologies" },
  { id: 5, name: "Leadership", slug: "leadership", count: 5, description: "Leadership lessons, management insights, and organizational development" }
];

// Blog Tags - ADMIN FULLY MANAGEABLE (Can add/edit/delete)
export const tags = [
  "venture-capital", "startup-ecosystem", "financial-modeling", "due-diligence", 
  "market-research", "business-strategy", "go-to-market", "fundraising",
  "software-engineering", "python", "azure", "data-analysis", "power-bi",
  "leadership", "public-speaking", "project-management", "team-building",
  "india-startup", "emerging-markets", "technology-trends", "ai-ml"
];

// Blog Posts - ADMIN FULLY MANAGEABLE (CRUD operations)
export const blogPosts = [
  {
    id: 1,
    title: "The Evolution of India's VC Landscape: A Fellow's Perspective",
    slug: "india-vc-landscape-evolution-fellow-perspective",
    excerpt: "Analyzing the rapid transformation of India's venture capital ecosystem from a ground-level perspective through my fellowship experience.",
    content: `# The Evolution of India's VC Landscape: A Fellow's Perspective

Through my fellowship at Lead by Bower, I've had the unique opportunity to observe and participate in India's rapidly evolving venture capital landscape.

## Key Observations

The Indian VC ecosystem has matured significantly, with several notable trends:

### 1. Sector Diversification
- Beyond traditional tech, we're seeing investments in deep-tech, healthcare, and sustainability
- Regional startups gaining significant traction outside metro cities

### 2. Capital Efficiency Focus
- Post-pandemic emphasis on unit economics and sustainable growth
- Longer runway strategies becoming standard practice

## Investment Thesis Development

During my fellowship, I've developed comprehensive investment frameworks focusing on:
- Market size and addressability analysis
- Founder-market fit evaluation
- Technology moat assessment
- Scalability potential

## Conclusion

The future of Indian VC looks promising with increased sophistication in deal evaluation and a growing focus on sustainable business models.

*Published on December 20, 2024*`,
    category: "Venture Capital",
    categorySlug: "venture-capital", 
    tags: ["venture-capital", "india-startup", "investment-thesis", "market-analysis"],
    publishedAt: "2024-12-20",
    readTime: "6 min read",
    featured: true,
    author: "Jaswanth Vasudeva",
    views: 1250,
    likes: 89,
    status: "published" // published, draft, archived
  },
  {
    id: 2,
    title: "Building Sales Functions from Zero: Lessons from Godaari Cacao",
    slug: "building-sales-functions-zero-godaari-cacao-lessons",
    excerpt: "How we built a sales function from scratch and achieved INR 1M+ net profit in 6 months through strategic planning and execution.",
    content: `# Building Sales Functions from Zero: Lessons from Godaari Cacao

When I joined Godaari Cacao as Head of Strategy & Sales, the challenge was clear: build a sales function from the ground up in a competitive market.

## The Challenge

Starting with no existing sales infrastructure, we needed to:
- Understand market dynamics and customer needs
- Develop pricing strategies and sales processes
- Build customer acquisition channels
- Establish sustainable revenue streams

## Strategic Approach

### Market Research & Analysis
We conducted comprehensive market research to understand:
- Target customer segments and their pain points
- Competitive landscape and positioning opportunities
- Pricing sensitivity and value proposition alignment

### Go-to-Market Strategy
Our GTM strategy focused on:
- Direct sales through relationship building
- Strategic partnerships with distributors
- Digital marketing and content-driven lead generation

## Results Achieved

In 6 months, we achieved:
- INR 1M+ in net profit
- Established sales processes and customer pipeline
- Built strong market presence in target segments

## Key Learnings

1. **Data-Driven Decision Making**: Every strategy decision was backed by market data
2. **Agile Execution**: Quick iterations based on customer feedback
3. **Relationship Focus**: Long-term customer relationships over short-term gains

*Published on December 15, 2024*`,
    category: "Strategic Analysis",
    categorySlug: "strategic-analysis",
    tags: ["business-strategy", "sales", "go-to-market", "startup-insights"],
    publishedAt: "2024-12-15",
    readTime: "8 min read",
    featured: true,
    author: "Jaswanth Vasudeva", 
    views: 892,
    likes: 67,
    status: "published"
  },
  {
    id: 3,
    title: "Engineering to VC: Transitioning Career Paths in Tech",
    slug: "engineering-to-vc-transitioning-career-paths-tech",
    excerpt: "My journey from software engineering at Carl Zeiss to venture capital fellowship, and lessons learned during the transition.",
    content: `# Engineering to VC: Transitioning Career Paths in Tech

The transition from software engineering to venture capital isn't straightforward, but it's increasingly common in today's tech ecosystem.

## My Transition Journey

### From Code to Capital
Moving from Carl Zeiss (software engineering) to Lead by Bower (VC fellowship) required:
- Developing business acumen alongside technical skills
- Understanding financial modeling and valuation methods
- Learning to evaluate startups beyond just technical merit

### Skills Translation
Many engineering skills translate well to VC:
- **Problem-solving**: Debugging code vs. identifying business challenges
- **Systems thinking**: Architecture design vs. business model evaluation
- **Data analysis**: Performance optimization vs. market research

## Challenges Faced

1. **Learning Curve**: Business terminology and financial concepts
2. **Network Building**: Moving from technical to business communities
3. **Evaluation Criteria**: Shifting from technical to commercial viability focus

## Advice for Engineers Considering VC

- Start building business knowledge early
- Engage with startup communities and founders
- Develop strong communication skills for non-technical audiences
- Maintain technical depth while building business breadth

The combination of technical background and business acumen creates unique value in today's tech-driven investment landscape.

*Published on December 10, 2024*`,
    category: "Leadership",
    categorySlug: "leadership",
    tags: ["career-transition", "venture-capital", "software-engineering", "leadership"],
    publishedAt: "2024-12-10",
    readTime: "7 min read",
    featured: false,
    author: "Jaswanth Vasudeva",
    views: 634,
    likes: 45,
    status: "published"
  }
];

// Featured posts are dynamically filtered from blogPosts
export const featuredPosts = blogPosts.filter(post => post.featured);

// Site Settings - ADMIN FULLY MANAGEABLE
export const siteSettings = {
  siteName: "Jaswanth Vasudeva",
  siteTitle: "Jaswanth Vasudeva - VC Fellow & Strategic Leader",
  metaDescription: "Personal portfolio and insights from Jaswanth Vasudeva, VC/PE Fellow at Lead by Bower, strategic leader, and engineering graduate.",
  favicon: null, // Admin can upload custom favicon
  logo: null, // Admin can upload site logo
  
  // Social sharing defaults
  ogImage: null, // 1200x630px for social media sharing
  
  // Analytics - Admin can configure
  googleAnalytics: "", // GA tracking ID
  
  // Contact form settings
  contactEmail: "jaswanthvedantam@gmail.com",
  
  // Admin access control
  adminEnabled: true, // Admin can disable admin features
  
  // Theme customization - Admin editable
  theme: {
    primaryColor: "#2563eb", // Blue
    secondaryColor: "#7c3aed", // Purple
    accentColor: "#059669", // Green
    backgroundColor: "#f9fafb", // Light gray
    textColor: "#1f2937" // Dark gray
  }
};